import HeaderTextButton from "@/components/HeaderTextButton";
import {useMemo} from "react";
import ProgramUpsertDialog from "@/features/programs/components/ProgramUpsertDialog";
import ProgramTable from "@/features/programs/components/ProgramTable";
import {useQueryModal} from "@/hooks/useQueryModal";
import {useTableQuery} from "@/hooks/useTableQuery";

import {Program, SortField, useDeleteProgram, usePrograms,} from "@/hooks/usePrograms";

export default function AdminProgramsPage() {
    const {
        searchParams,
        editId,
        isNew,
        modalOpen,
        setParam,
        openCreate,
        openEdit,
        closeModal,
    } = useQueryModal();

    const {
        page,
        size,
        sortBy,
        sortOrder,
        setPage,
        onRequestSort,
    } = useTableQuery<SortField>({
        searchParams,
        setParam,
        defaultPage: 0,
        defaultSize: 12,
        defaultSortBy: "title",
        defaultSortOrder: "asc",
    });

    const {
        data: result,
        isLoading,
        isError,
    } = usePrograms({page, size, sortBy, sortOrder});

    const {mutateAsync: deleteProgram} = useDeleteProgram();

    const initialForDialog: Partial<Program> | null = useMemo(() => {
        if (isNew) return null;
        if (editId) return (result.items as Program[]).find((p) => p.id === editId) ?? null;
        return null;
    }, [isNew, editId, result]);

    return (
        <>
            <HeaderTextButton
                title="Programs"
                description="Manage radio programs, day-of-week schedules and special overrides."
                label="Add Program"
                onClick={openCreate}
            />

            <ProgramTable
                content={result}
                isLoading={isLoading}
                isError={isError}
                onCreate={openCreate}
                onEdit={openEdit}
                onDelete={deleteProgram}
                setPage={setPage}
                sortBy={sortBy}
                sortOrder={sortOrder}
                onRequestSort={onRequestSort}
            />

            <ProgramUpsertDialog
                open={modalOpen}
                initial={initialForDialog}
                onClose={closeModal}
            />
        </>
    );
}
